import React, { useEffect, useRef } from "react";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { Svg24 as ClearFilled } from "@swiggy-private/dls-web-icons/dist/web/generic/clearFilled";
import { Images } from "../../../constants/images";
import { DLS_TEXT_VARIANTS } from "../../../constants/dls";
import {
    ModalOverlay,
    ModalContent,
    CloseButton,
    SuccessImage,
    ModalTitle,
    ModalButton,
} from "../../../styles/referralModal";
import {
    logReferredSuccessfullyCardImpression,
    logReferredSuccessfullyCardReferSomeoneElseClick,
    logReferredSuccessfullyCardCloseClick,
} from "../analytics";

interface ReferralSuccessModalProps {
    onClose: () => void;
    referredPersonDetails?: Record<string, any>;
}

const ReferralSuccessModal = ({ onClose, referredPersonDetails }: ReferralSuccessModalProps) => {
    const hasTrackedImpression = useRef(false);

    useEffect(() => {
        if (!hasTrackedImpression.current && referredPersonDetails) {
            logReferredSuccessfullyCardImpression(referredPersonDetails);
            hasTrackedImpression.current = true;
        }
    }, [referredPersonDetails]);

    const handleReferSomeoneElse = () => {
        logReferredSuccessfullyCardReferSomeoneElseClick();
        onClose();
    };

    const handleClose = () => {
        logReferredSuccessfullyCardCloseClick();
        onClose();
    };

    return (
        <ModalOverlay onClick={handleClose}>
            <ModalContent>
                <CloseButton onClick={handleClose}>
                    <GenericIcon Icon={ClearFilled} fillColor="text_Med_Emphasis" />
                </CloseButton>
                <SuccessImage src={Images.referSuccess} />
                <ModalTitle variant={DLS_TEXT_VARIANTS.HEADING_H2_BOLD}>Referred Successfully! 🎉</ModalTitle>
                <ModalButton variant="primary" onClick={handleReferSomeoneElse}>
                    Refer someone else
                </ModalButton>
            </ModalContent>
        </ModalOverlay>
    );
};

export default ReferralSuccessModal;
